import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays, Clock } from "lucide-react";
import SubLayout from "@/components/site/SubLayout";
import Breadcrumbs from "@/components/site/Breadcrumbs";
import CtaBlock from "@/components/site/CtaBlock";
import Seo from "@/seo/Seo";
import { breadcrumbSchema, websiteSchema, localBusinessSchema } from "@/seo/schemas";
import { POSTS } from "@/data/blog";

export default function Blog() {
  const path = "/blog";
  const title = "VIN Verification Blog | Guides & California DMV Tips | The VIN Verifier CA";
  const description = "Expert guides on California VIN verification, DMV REG 31, out-of-state registration, trailers, motorcycles, RVs and more from a licensed vehicle verifier.";
  const schema = [breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Blog", path }]), websiteSchema(), localBusinessSchema()];

  return (
    <SubLayout>
      <Seo title={title} description={description} path={path} schema={schema} />
      <section className="bg-gradient-to-b from-mist to-white">
        <div className="max-w-6xl mx-auto px-5 lg:px-8 py-10 lg:py-14">
          <Breadcrumbs items={[{ name: "Home", path: "/" }, { name: "Blog", path }]} />
          <h1 className="font-display font-extrabold text-ink tracking-tight text-3xl sm:text-4xl lg:text-5xl mt-5">VIN Verification Guides & Tips</h1>
          <p className="text-slate2 text-lg mt-4 max-w-2xl">Clear, practical answers about California VIN verification, DMV forms, and registering every kind of vehicle.</p>
        </div>
      </section>

      <div className="max-w-6xl mx-auto px-5 lg:px-8 py-14 lg:py-20">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {POSTS.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="card-soft p-7 flex flex-col group">
              <div className="flex items-center gap-3 text-xs text-slate2">
                <span className="flex items-center gap-1"><CalendarDays size={13} /> {new Date(p.date).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}</span>
                <span className="flex items-center gap-1"><Clock size={13} /> {p.read}</span>
              </div>
              <h2 className="font-display font-semibold text-ink text-xl mt-3 group-hover:text-brand transition-colors">{p.title}</h2>
              <p className="text-slate2 text-sm mt-2 leading-relaxed flex-1">{p.excerpt}</p>
              <span className="text-brand font-semibold text-sm mt-4 inline-flex items-center gap-1">Read more <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" /></span>
            </Link>
          ))}
        </div>
        <div className="mt-16"><CtaBlock /></div>
      </div>
    </SubLayout>
  );
}
